<template>
  <router-view class="answer_body" />
</template>

<script>
export default {
  data () {
    return {

    }
  },
  provide () {
    return {

    }
  },
  methods: {

  }
}
</script>
<style lang="less">
html,
body {
  height: 100%;
}
.answer_body {
  height: 100%;
}
</style>
